export default "/Frontend/dist/doc-fallback.8bb2a3e97389d3ece81b23f4f1e96573.svg";